// extracted by mini-css-extract-plugin
export default {"testimonials":"styles_testimonials__OkYRn","testimonials__row":"styles_testimonials__row__Jl3nq"};